<div class="vertical-stepper">
  <div
    [ngStyle]="{
      height: lineHeight + 'px',
    }"
    class="line"
  ></div>
  <div
    *ngFor="let step of steps; let i = index"
    class="step-wrapper {{ activeStepIndex === i ? 'active-step' : '' }} {{
      activeStepIndex > i ? 'visited-step' : ''
    }}"
  >
    <div
      *ngIf="activeStepIndex > i"
      [ngStyle]="{
        height: getActiveLineHeight(i, true),
      }"
      class="line active-line"
    ></div>
    <div class="step-index sub-heading-l">
      <div class="index">{{ i + 1 }}</div>
    </div>
    <div class="step-text">
      <div class="step-header body-bold-l">{{ step.headerText }}</div>
      <div class="step-subheader body-m">{{ step.subHeaderText }}</div>
    </div>
    <div
      *ngIf="activeStepIndex === i && !(activeStepIndex === steps.length - 1)"
      [ngStyle]="{
        height: getActiveLineHeight(i),
      }"
      class="line active-line"
    ></div>
  </div>
</div>
